<template>
    <div>
        <el-card class="box-card">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/BusManage-Detail' }">商家管理</el-breadcrumb-item>
                <el-breadcrumb-item>详情</el-breadcrumb-item>
            </el-breadcrumb>
        </el-card>
        <el-card>
            <el-row :gutter="20">
                <el-col :span="20" :offset="2">
                    <div class="grid-content bg-purple">
                        <el-form :model="tableData" ref="ruleForm" :rules="rules" label-width="100px">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="商家类型" prop="merchantType" readonly>
                                        <el-input v-model="tableData.merchantType" readonly></el-input>
                                    </el-form-item>
                                </el-col>
                                 <el-col :span="12">
                                    <el-form-item label="门店名称" prop="key">
                                        <el-input v-model="tableData.merchantName" readonly></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="工作时间" prop="key">
                                        <el-time-picker
                                            v-model="tableData.startWorkTime"
                                            class="date-box"
                                            format="HH:mm"
                                            value-format="HH:mm"
                                        >
                                        </el-time-picker>
                                        <el-time-picker v-model="tableData.endWorkTime" format="HH:mm" value-format="HH:mm">
                                        </el-time-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="用户名" prop="key">
                                        <el-input v-model="tableData.merchantLoginName" readonly></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="登录密码" prop="key">
                                        <el-input v-model="tableData.merchantPassword" type="password" show-password readonly></el-input>
                                    </el-form-item>
                                </el-col>
                                 <el-col :span="12">
                                    <el-form-item label="商家卖点" prop="key">
                                        <el-input v-model="tableData.merchantFeatures"  readonly></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="联系电话" prop="key">
                                        <el-input v-model="tableData.merchantTelephone" readonly></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                   <el-form-item label="门店服务" prop="key">
                                         <el-input v-model="tableData.merchantServer" readonly></el-input>
                                    </el-form-item>  
                                </el-col>
                            </el-row>
                             <el-form-item label="门店地址" prop="key" class="address">
                                <el-row>
                                <el-col :span="2">
                                <el-input v-model="tableData.province" readonly></el-input>
                                </el-col>
                                <el-col :span="2">
                                <el-input v-model="tableData.city" readonly></el-input>
                                </el-col>
                                <el-col :span="2">
                                <el-input v-model="tableData.area" readonly></el-input>
                                </el-col>
                                <el-col :span="5">
                                <el-input v-model="tableData.merchantAddress" readonly></el-input>
                                </el-col>
                               
                            </el-row>
                             </el-form-item>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="logo图片" prop="key">
                                        <el-upload class="avatar-uploader" :show-file-list="false" :action="uploadUrl" disabled>
                                            <img :src="imageUrl" class="avatar" />
                                        </el-upload>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="二维码图片" prop="key">
                                        <el-upload class="avatar-uploader" :show-file-list="false" :action="uploadUrl" disabled>
                                            <img :src="merchantQRUrl" class="avatar" />
                                        </el-upload>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-form-item label="资质照片" prop="key">
                                <el-upload class="avatar-uploader" :show-file-list="false" :action="uploadUrl" disabled>
                                    <img :src="quaImageUrl" class="avatar" />
                                </el-upload>
                            </el-form-item>
                                    <el-form-item label="门店简介" prop="key">
                                        <span class="editorContainerInfo ql-editor activesImg" v-html="tableData.merchantIntroduction"></span>
                                    </el-form-item>
                            <div class="dialog-footer">
                                <el-button type="primary" plain @click="returnPage">返回</el-button>
                            </div>
                        </el-form>
                    </div>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<script>
import city from '@/assets/json/map.json';
export default {
    data() {
        return {
            tableData: {},
            id: '',
            // 新增表单数据
            imageUrl: '',
            options: [
                {
                    value: '1',
                    label: '1'
                },
                {
                    value: '2',
                    label: '2'
                }
            ],
            status: [
                {
                    value: '0',
                    label: '未营业'
                },
                {
                    value: '1',
                    label: '正在营业'
                }
            ],
            showType: [
                {
                    value: '0',
                    label: '不显示'
                },
                {
                    value: '1',
                    label: '新上商家'
                },
                {
                    value: '2',
                    label: '我们都在选'
                },
                {
                    value: '3',
                    label: '优惠排行'
                },
                {
                    value: '4',
                    label: '热门排行'
                },
                {
                    value: '5',
                    label: '热别活动'
                }
            ],
            // 验证规则
            rules: {},
            uploadUrl: 'upload/fileupload', //图片上传地址
            // 整个省市县数据
            city: city,
            // 被选中的市数据
            cityList: [],
            // 被选中的县数据
            areaList: [],
            selectProvince: {},
            selectCity: {},
            selectArea: {},
            imageUrl: '',
            merchantQRUrl: '',
            quaImageUrl: '' //资质图片
        };
    },
    created() {

        this.id = this.$route.query.id;

        //this.getMerchantInfo();
    },
    methods: {
        async getMerchantInfo() {
            const res = await this.$axios.post('merchant/getData', {
                id: this.id
            });
            console.log(res);

            if (res.data.code == 0) {
                this.tableData = res.data.data;
                this.imageUrl = res.data.data.merchantImgUrl;
                this.merchantQRUrl = res.data.data.merchantQRUrl;
                this.quaImageUrl = res.data.data.merchantQuantityImgUrl;
                console.log(this.tableData);
            }
        },
        returnPage() {
            // 跳转上一级
            // 这个判断用来解决这种情况，当用户没有上一条路由的历史记录，出现点击返回按钮没有反应时，下面的代码用来判断有没有上一条路由的历史记录   如果没有则返回首页
            if (window.history.length <= 1) {
                this.$router.push({ path: '/home' });
                return false;
            } else {
                this.$router.go(-1);
            }
        }
    }
};
</script>
<style scoped>
.el-select {
    width: 100%;
}
.address .el-select {
    width: 33.33%;
    margin-bottom: 10px;
}

.avatar {
    width: 148px;
    height: 148px;
    display: block;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
    border: 1px dashed #d9d9d9;
}
.dialog-footer {
    text-align: center;
}
.el-button {
    margin-bottom: 20px;
    width: 80px;
    font-size: 14px;
    font-weight: bold;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 50%;
}
</style>
